@let data = dataMenu$ | async;
@defer (on immediate) {
  <app-promotion />
}
@if (data) {
  <app-navigation [data]="data" />
}
<router-outlet />
@if (data) {
  <app-footer [data]="data" />
}
@defer (on idle) {
  <app-delayed-scripts />
}
